<template>
  <div class="projectList">
    <div class="distributionBox" v-for="(item, index) in list" :key="index" @click="detail(item.id, item.isMyPub)">
      <div class="personInformationBox">
        <div>
          <img class="user-headImg" src="../assets/images/publicImg/touxiang_default.png"
               v-if="!item.headImg">
          <img :src="item.headImg" v-else class="user-headImg" @click.stop="imagePreview(item.headImg)">
        </div>
        <div class="person-info">
          <div class="name van-multi-ellipsis--l2 work-name">
            {{ item.name }}
          </div>
          <div class="tag-div">
            <van-tag plain class="is-auth-tag" size="medium" v-if="item.isAuth === 1">已实名
            </van-tag>
            <van-tag plain color="#999999" text-color="#999999" size="medium" v-if="item.isAuth === 0">未实名
            </van-tag>
            <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.type === 0">个人
            </van-tag>
            <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.type === 1">班组
            </van-tag>
            <van-tag plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium" v-if="item.type === 2">企业
            </van-tag>
          </div>
        </div>
      </div>
      <div class="information" v-for="(val, ind) in item.datas" :key="ind" v-if="val.id !== 'score'">
        <span>{{ val.key }}： </span>
        {{ val.value }}
      </div>

      <div class="intro van-ellipsis"> {{ item.content }}</div>

      <div class="intro-img-div">
        <img v-for="(val, ind) in item.attachments" :key="ind" :src="val.attachUrl"
             @click.stop="getImg(item.attachments, ind)"
             class="intro-img">
      </div>

      <div class="bottomBox">
        <div v-show="item.status === 0">
          <span class="icon_circle666"></span>
          <span>暂不找工作</span>
        </div>
        <div v-show="item.status === 1">
          <span class="icon_circle"></span>
          <span>正在找工作</span>
        </div>
        <div>
          <img src="../assets/images/publicImg/btn_phone.png" class="btn_phone"
               @click.stop="callPhone(item.id, 2)">
        </div>
      </div>
      <span class="iconImg icon_zhiding" v-show="item.isTop === 1"></span>
    </div>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>

    <callBack :dataType="2" :dataId="dataId" ref="callBack"/>
  </div>
</template>

<script>
import imagePopup from '@components/imagePopup/imagePopup'
import { callByCoin, onceCallCoins } from '@api/integralMall'
import callBack from '@/components/callBack'
import { ImagePreview } from 'vant'

export default {
  name: 'projectList',
  props: ['list', 'dataId'],
  components: {
    imagePopup, callBack
  },
  data () {
    return {
      demo: ['http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default.png',
        'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default.png',
      ],
      showImagePopup: false,
      imgUrl: '',
      idByPhone: undefined, // 用于支付成功后回调拨打电话
      isToPay: false, // 是否已去支付
      version: undefined
    }
  },
  mounted () {
    this.token = localStorage.getItem('token')
    this.version = this.$route.query.version;

    this.startTime = Date.now()
    // 初始化极光统计
    this.$jiguang.initCountEvent()

    // 支付回调
    this.$bridge.registerHandler('paySuccess', (data, responseCallback) => {
      if (this.idByPhone && this.isToPay) {
        this.payment(this.idByPhone)
      }
    })

    // 电话回调
    this.$bridge.registerHandler('callBack', (data, responseCallback) => {
      this.$refs.callBack.showFeedback()
    })
  },
  methods: {

    // 调用拨号功能
    callPhone (id, type) {
      this.dataId = id
      if (this.token && this.token !== 'undefined') {

        onceCallCoins({
          dataType: 2,
          dataId: id
        }).then(res => {
          if (res.data.code === 200) {

            if (res.data.data.firstFlag === true) {
              // 获取极光统计所需数据
              this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
                console.log('response:', response)
              })

              this.$dialog.confirm({
                title: '拨打电话',
                message:
                  `拨打电话，需要支付${res.data.data.value}个邀工币。`,
                confirmButtonColor: '#096CEFFF'
              })
                .then(() => {
                  this.idByPhone = id
                  this.payment(id)
                })
                .catch(() => {
                  // on cancel
                })
            } else {
              callByCoin({
                dataType: 2,
                dataId: id
              }).then(res => {
                if (res.data.code === 200) {
                  const phoneNumber = res.data.data.phone
                  const data = { phone: phoneNumber }
                  this.$bridge.callHandler('callPhone', data, response => {
                    console.log('response:', response)
                  })
                }
              })
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      } else {
        // 登录页面
        this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
          console.log('response:', response)
        })
      }
    },

    // 判断邀功币是否充足
    payment (id) {
      callByCoin({
        dataType: 2,
        dataId: id
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            this.isToPay = true
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 查看详情
    detail (id, isMyPub) {
      this.isToPay = false
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_recruitment_list_browser,招工列表,招工,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_view_zhaohuo', response => {
        console.log('response:', response)
      })
      // this.enterRouter('distributionDetail', { id: id })
      if (isMyPub === 1) {
        if(this.version && this.$utils.compareVersion(this.version,'4.6.3') >= 0){
          //ios和安卓>=4.6.3以上,找活发布跳转内部原生
          this.$bridge.callHandler('findWorkPubPageApp', {},response => {
            console.log('response:', response)
          })
        }else{
          const data = {
            url: `${process.env.VUE_APP_BASE_HOST}/getWorkAdvertising`,
            title: '找活广告'
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        }
      } else {
        const data = {
          url: `${process.env.VUE_APP_BASE_HOST}/distributionDetail?id=${id}&isMyPub=${isMyPub}`,
          title: '找活名片'
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      }
    },

    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    },

    getImg (images, index) {
      let list = []
      for (let i = 0; i < images.length; i++) {
        list.push(images[i].attachUrl)
      }
      ImagePreview({
        images: list,
        showIndex: true,
        loop: false,
        startPosition: index
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/mixin";

.projectList {
  .WRASText {
    @include add_size($font_size_18);
    color: #999;
    font-weight: 400;
  }

  .personInformationBox {
    padding-bottom: 5px;
  }

  .user-headImg {
    border-radius: 5px;
    width: 50px;
    height: 50px;
    margin-right: 12px;
  }

  .tag-div {
    font-size: 18px;

    .van-tag {
      background-color: #096CEF12;
      font-size: 13px;
      margin-right: 3px;
      padding: 3px 5px;
    }
  }

  .person-info {
    .work-name {
      -webkit-line-clamp: 1;
      font-weight: 500;
      @include add_size($font_size_17);
    }
  }

  .information {
    padding-bottom: 3px;
    @include add_size($font_size_16);
  }

  .intro {
    color: #999999FF;
    padding: 5px 0;
    @include add_size($font_size_16);
  }

  .intro-img-div {
    overflow: hidden;
    max-height: 80px;
  }

  .intro-img {
    float: left;
    margin: 5px;
    width: 70px;
    height: 70px;
  }

  .bottomBox {
    @include add_size($font_size_12);
  }

  .distributionBox .bottomBox span {
    @include add_size($font_size_14);
  }

  .btn_phone {
    width: 100px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}
</style>
